// extracted by mini-css-extract-plugin
export default {"headerBar":"kK-z","pointsSection":"lK-z","goToDashboard":"mK-z"};